import React from 'react';
import { Navigate, useParams} from 'react-router-dom';

export function PrivateRoute({children }) {
    const { school } = useParams();
    const user = sessionStorage.getItem('user');
    return user!==null ? children : <Navigate to={`/${school}/signin`} />;
  }